var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 124",
    d: "M1 16a1 1 0 01-1-1V7a1 1 0 011-1h1V4a4 4 0 014-4 4 4 0 014 4v2h1a1 1 0 011 1v8a1 1 0 01-1 1zM8.4 6V3.924a2.4 2.4 0 00-2.4-2.4 2.4 2.4 0 00-2.4 2.4V6z",
    fill: "#fff"
  })));
}
export default SvgSecureIcon;